import { oktaAuthHandler } from '@choreograph/authjs'
import { renderReactAppRoot, createMSAppProvider } from '@choreograph/layout'
import store from './state/store'
import App from './App'

// @ts-expect-error -- ENV is injected by build-time config
oktaAuthHandler.setEnv(process.env.ENV)

const ProviderWrapper = createMSAppProvider(App, store)

// UNCOMMENT TO RUN APP WITH MOCK DATA
// INITIALISE MSW BEFORE FIRST RUN - `npx msw init public/ --save`
// import allHandlers from './mocks/mswHandlers'
// import { MSWBrowser } from '@choreograph/services/lib/msw/MSWBrowser'
// if (process.env.NODE_ENV === 'development') {
//   MSWBrowser(allHandlers)
// }

renderReactAppRoot(ProviderWrapper)
